"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styles = require("./styles");

var Container = (0, _base["default"])("div", {
  target: "e1qr0t170",
  label: "Container"
})(_styles.styles.base, ";"); // https://css-tricks.com/building-progress-ring-quickly/

var ProgressRing = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var radius = _ref.radius,
      stroke = _ref.stroke,
      className = _ref.className,
      completedCount = _ref.completedCount,
      total = _ref.total,
      color = _ref.color;
  var normalizedRadius = radius + stroke * 2;
  var circumference = radius * 2 * Math.PI;
  var strokeDashoffset = circumference - completedCount / total * circumference;
  return (0, _jsxRuntime.jsxs)(Container, {
    className: className,
    ref: ref,
    stroke: stroke,
    color: color,
    children: [(0, _jsxRuntime.jsxs)("svg", {
      height: normalizedRadius * 2,
      width: normalizedRadius * 2,
      children: [(0, _jsxRuntime.jsx)("circle", {
        fill: "transparent",
        strokeWidth: stroke,
        style: {
          strokeDashoffset: strokeDashoffset
        },
        r: radius,
        cx: normalizedRadius,
        cy: normalizedRadius,
        css: _styles.styles.backgroundCircle
      }), (0, _jsxRuntime.jsx)("circle", {
        fill: "transparent",
        strokeWidth: stroke,
        strokeDasharray: "".concat(circumference, " ").concat(circumference),
        style: {
          strokeDashoffset: strokeDashoffset
        },
        r: radius,
        cx: normalizedRadius,
        cy: normalizedRadius,
        css: _styles.styles.progressCircle
      })]
    }), (0, _jsxRuntime.jsx)("span", {
      css: _styles.styles.step,
      children: completedCount
    })]
  });
});
ProgressRing.propTypes = {
  className: _propTypes.string,
  radius: _propTypes.number,
  stroke: _propTypes.number,
  total: _propTypes.number,
  completedCount: _propTypes.number,
  color: _propTypes.string
};
ProgressRing.defaultProps = {
  className: undefined,
  radius: 10,
  stroke: 3,
  total: 100,
  completedCount: 0,
  color: 'color.brand.primary'
};
ProgressRing.displayName = 'ProgressRing';
var _default = ProgressRing;
exports["default"] = _default;
//# sourceMappingURL=ProgressRing.js.map